import { ConnectionPointDto, MeterFrameDto } from '@app/api/nts';
import { Columns } from '@shared/interfaces/table/column-config';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';
import { DecimalCellComponent } from '@shared/components/table/cells/decimal-cell/decimal-cell.component';

export const systemServicesDetailsMasterdata: Columns<ConnectionPointDto | MeterFrameDto>[] = [
  {
    title: 'systemServices.type',
    key: 'systemServicesType',
    cellRenderer: TranslateCellComponent,
    cellRendererParams: {
      notspecified: 'systemServices.types.NotSpecified',
      fcrup: 'systemServices.types.FcrUp',
      fcrdown: 'systemServices.types.FcrDown',
      afrrup: 'systemServices.types.AfrrUp',
      afrrdown: 'systemServices.types.AfrrDown',
      mfrrup: 'systemServices.types.MfrrUp',
      mfrrdown: 'systemServices.types.MfrrDown',
    },
  },
  {
    title: 'systemServices.capacity',
    key: 'systemServicesCapacity',
    cellRenderer: DecimalCellComponent,
    cellRendererParams: { decimals: 1 },
  },
];
